import { Cancel as CancelIcon } from "@mui/icons-material";
import { Chip, Tooltip } from "@mui/material";
import React from "react";

const FILTER_CHIP_BASE_SX = {
  fontWeight: 500,
  fontSize: "0.75rem",
  "& .MuiChip-label": {
    px: 1.5,
    py: 0.5,
  },
};
export const FilterChip = ({ label, onDelete, tooltip, sx }) => {
  const normalizedSx = Array.isArray(sx) ? sx : sx ? [sx] : [];
  const chipSx =
    normalizedSx.length > 0
      ? [FILTER_CHIP_BASE_SX, ...normalizedSx]
      : FILTER_CHIP_BASE_SX;
  const chip = (
    <Chip
      label={label}
      size={"small"}
      onDelete={onDelete}
      deleteIcon={
        <Tooltip title={"Remove filter"} arrow>
          <CancelIcon />
        </Tooltip>
      }
      sx={chipSx}
    />
  );
  return tooltip ? (
    <Tooltip title={tooltip} arrow>
      {chip}
    </Tooltip>
  ) : (
    chip
  );
};
export default FilterChip;
